import { Injectable } from '@angular/core';
import { HttpUtils } from '../../../shared/http/HttpUtils';
import { CreateSubscriptionApiRequest } from './Request/CreateSubscriptionApiRequest';
import { CreateSubscriptionApiResponse } from './Response/CreateSubscriptionApiResponse';

@Injectable({
    providedIn: 'root'
})

export class CreateSubscriptionApi
{
    private apiUrl = '/api/subscription/create';

    public async PostAsync(request: CreateSubscriptionApiRequest): Promise<string>
    {
        const response = await fetch(this.apiUrl, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(request)
        });

        await HttpUtils.ProcessFetchResultAsync(response);

        const responseObject = await response.json() as CreateSubscriptionApiResponse;

        return responseObject.CheckoutUrl;
    }
}
